import { api } from '@services';

interface IAddFileToTask {
  taskId: string;
  file: File;
}

const addFileToTask = async ({
  file,
  taskId,
}: IAddFileToTask): Promise<void> => {
  const formData = new FormData();

  formData.append('file', file);

  await api.post(`/tasks/${taskId}/files`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export { addFileToTask };
